
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/vercel/path0/apps/front/sentry.client.config.ts")
            }
          });